import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class MediaServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(id, params = {}) {
    return this.http.get(`campaigns/${id}/mediafiles/select`, { params });
  }

  removeItem(id) {
    return this.http.delete(`/${id}`);
  }

}

export const MediaService = new MediaServiceClass({
  api_version: 2,
  resource: 'informer'
});
